import styled from 'styled-components';
import { breakpoints, colors, fonts } from '@vfit/shared/themes';

export const DisclaimerLiteContainer = styled.div`
  div {
    margin-top: 24px;
  }
  font-family: ${fonts.regular};
  font-weight: 400;
  color: ${colors.$7e7e7e};
  img {
    width: 18px;
  }

  p {
    margin-top: 0;
  }

  @media (min-width: ${breakpoints.desktop}) {
    div {
      margin-top: 40px;
      margin-left: 80px;
      margin-right: 80px;
    }
  }
`;
